<template>
    <div class="con">
    <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>

        <div class="main wow fadeInUp">
        <div class="nav">
            <span v-for="(item,index) in $t('culture').navList" :key="index" :class="{'showLine':select===index}" @click="change(index)">{{item}}</span>
        </div>
        </div>

        <div class="mainCon">
            <transition name="fade">
                <div class="ln "  :class="{'enln':$i18n.locale === 'en'}" v-if="select===0">
                  <div class="one">
                      <img src="../assets/culture/cloud.png" alt="">
                      <p class="title wow fadeInUp">{{$t('culture').navList[0]}}</p>
                      <div class="content wow fadeInUp">
                          <p id="yj">{{$t('culture').text1[0]}}</p>
                          <p>{{$t('culture').text1[1]}}</p>
                          <p>{{$t('culture').text1[2]}}</p>
                      </div>
                  </div>
                    <div class="two wow fadeInUp" :class="{'enTwo':$i18n.locale === 'en'}">
                        <img src="../assets/culture/fly.png" alt="">
                        <div class="content wow fadeInUp">
                            <p id="sm">{{$t('culture').text1[3]}}</p>
                            <p>{{$t('culture').text1[4]}}</p>
                            <p>{{$t('culture').text1[5]}}
                            </p>
                        </div>
                    </div>
                    <div class="three">
                        <div class="t1 wow fadeInUp">
                          <p id="hx">{{$t('culture').text1[6]}}</p>
                            <p>君行正道 安积德义</p>
                        </div>
                        <div class="items wow fadeInUp">
                           <div class="item" v-for="(item,index) in list" :key="index">
                               <img :src="item.img" alt="">
                               <div class="c">
                                   <p>{{item.text}}</p>
                               </div>
                           </div>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="fade">
             <div class="sh" v-if="select===1">
                 <p class="title">{{$t('culture').navList[1]}}</p>
                 <div class="lm">
               <div class="item" v-for="(item,index) in lifeList" :key='index'>
                   <router-link :to="{path: 'newsInfo2',query:{id:item.ID}}" target="_blank">
                   <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                   <div class="f">
                       <span>{{item.TITLE}}</span>
                       <span>{{item.NOTETIME}}</span>
                   </div>
                   </router-link>
               </div>
                 </div>
                 <div style="text-align: center;font-size: 14px;" @click="showMore">
                     <span>{{$t('about').text2}}</span>
                     <btn-Component></btn-Component>
                 </div>
             </div>
            </transition>

            <transition name="fade">
                <div class="sh" v-if="select===2">
                    <p class="title">{{$t('culture').navList[2]}}</p>
                    <div class="lm">
                        <div class="item" v-for="(item,index) in dutyList" :key='index'>
                            <router-link :to="{path: 'newsInfo2',query:{id:item.ID}}" target="_blank">
                            <div class="on">
                                <img :src="`http://junankg.com/upload/${item.SMALLPIC}`" alt="">
                                <span>{{item.NOTETIME}}</span>
                            </div>
                            <div class="fa">
                               <p>{{item.TITLE}}</p>
                                <p>{{item.CON}}</p>
                            </div>
                            </router-link>
                        </div>
                    </div>
                    <div style="text-align: center;font-size: 14px;" @click="showMore">
                        <span>{{$t('about').text2}}</span>
                        <btn-Component></btn-Component>
                    </div>
                </div>
            </transition>

        </div>

        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import btnComponent from '../components/btn'
    import footComponent from '../components/foot'
    import { getNewsUrl} from '../util/lang'
    import Scrollbar from 'smooth-scrollbar'
    export default {
        name: "culture",
        data(){
            return{
                page:'',
                id:'',
                totalPage:'',
                list:[
                    {img:require('../assets/culture/girl-924903.png'),text:'探寻正道、践行正道，唯有正道，才能长远。君安不断探索、顺应自然、人类发展规律之天道，坚定不移地坚持诚实、守信、创新之商道，秉持公平正义、承担社会责任、维护社会正气之公道。'},
                    {img:require('../assets/culture/mountaineer-2080138.png'),text:'只有居安思危，多积德义，具有高度的危机感和忧患意识，我们才会始终保持清醒的头脑，自我施压，不断进取，奋发向上。'},
                    {img:require('../assets/culture/stairway-828883.png'),text:'行正道者致远，居安思危者寿长。君安人唯有铭记使命，战战兢兢、如履薄冰地走在正道上厚积德义，企业才能根深叶茂、源远流长，才能真正实现健康、持续、稳定成长，做到青春永葆、基业长青。'}
                ],
                enlist:[
                    {img:require('../assets/culture/girl-924903.png'),text:'Only by exploring and practicing the right path can we achieve long-term results. Junan constantly explores and conforms to the natural ways of nature and human development. It firmly adheres to the business principles of honesty, trustworthiness and innovation. Junan not only upholds fairness and justice, and undertakes social responsibilities, but also upholds the fairness of society.'},
                    {img:require('../assets/culture/mountaineer-2080138.png'),text:'Only when we live in peace and have a high sense of crisis , will we always keep a clear head to pressure on ourselves and keep making progress.'},
                    {img:require('../assets/culture/stairway-828883.png'),text:'Those who follow the right path will go far, and those who live in peace will live long. Only when we keep our mission in mind and build up our morals, can the enterprise truly achieve healthy, sustainable and stable growth, and achieve youthfulness and long-lasting foundation.'}
                ],
                lifeList:[],
                dutyList:[],
                select:0,
                navList:[
                    '君安理念',
                    '君安生活',
                    '社会责任'
                ],
                info:{
                    img:require('../assets/culture/ban.png'),
                    text0:'君安文化',
                    text1:'推动中国商业生态建设 推动中国经济社会全面进步'
                }
            }
        },
        components:{banComponent,footComponent,btnComponent},
        mounted(){
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            scrollbar.scrollTo(0,0)
            if( this.$i18n.locale === 'en'){
                this.info={
                    img:require('../assets/about/ban.png'),
                    text0:'JUNAN CULTURE',
                    text1:'Promote the construction of China\'s business ecology and  China\'s comprehensive economic and social progress.'
                }
                this.list=this.enlist
            }
            if(this.$route.query.index!==undefined){
                this.change(parseInt(this.$route.query.index-1))
            }else if(this.$route.query.top!==undefined){
                setTimeout(()=>{
                    this.goNext(parseInt(this.$route.query.top))
                },100)
            }
        },
        methods:{
            goNext(n){
                if(n===0){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#yj"),{
                        offsetTop: 80,
                    })
                }else if(n===1){
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#sm"),{
                        offsetTop: 80,
                    })
                }else{
                    Scrollbar.get(document.getElementById('scroller-wrapper')).scrollIntoView(document.querySelector("#hx"),{
                        offsetTop: 80,
                    })
                }
            },
            showMore(){
                if(this.page<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${getNewsUrl(this.$i18n.locale,this.id,6,this.page++)}`
                        this.$axios.get(url).then(res => {
                            res.data.newsArr.map((item)=>{
                                item.NOTETIME=item.NOTETIME.slice(0,11)
                            })
                            if(this.id==='24' || this.id==='31'){
                                this.lifeList= this.lifeList.concat(res.data.newsArr)
                            }else if(this.id==='25' || this.id==='32'){
                                this.dutyList=this.dutyList.concat(res.data.newsArr)
                            }
                        })

                    })
                }else{
                    this.$notify({
                        title: '提示',
                        message: '已经加载全部了',
                        offset: 100
                    });
                }
            },
            change(n){
                this.select=n
                if(n===1){
                    if( this.$i18n.locale === 'en'){
                        this.getNews('31')
                    }else{
                        this.getNews('24')
                    }
                }else if(n===2){
                    if( this.$i18n.locale === 'en'){
                        this.getNews('32')
                    }else{
                        this.getNews('25')
                    }
                }
            },
            getNews(id){
                this.page=2
                this.id=id
                const url = `${getNewsUrl(this.$i18n.locale,id,6,1)}`
                this.$axios.get(url).then(res => {
                    res.data.newsArr.map((item)=>{
                        item.NOTETIME=item.NOTETIME.slice(0,11)
                    })
                    if(id==='24' || this.id==='31'){
                        this.lifeList=res.data.newsArr
                    }else if(id==='25' || this.id==='32'){
                        this.dutyList=res.data.newsArr
                    }
                    this.totalPage=res.data.pagerShow.totalPagers
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .main{
        width:100%;
        padding: 1px 0;
        .nav{
            width:1000px;
            margin: 0 auto;
            display: flex;
            flex-direction: row;
            justify-content:center;
            span{
                display: inline-block;
                padding: 15px 80px;
                cursor: pointer;
                transition: all 2s;
                font-size: 15px;
                text-transform: uppercase;
            }
            span:hover{
                background-color: #0068B7;
                color:white;
            }
            .showLine{
                background-color: #0068B7;
                color:white;
            }
        }
    }
    .mainCon{
        width:100%;
        border-top: 1px solid rgba(0,0,0,.2);
        background-color: #F7F7F7;
        .ln{
            width:100%;
            .one{
                width:100%;
                position: relative;
                img{
                    width:100%;
                    object-fit: cover;
                    height:700px;
                }
                .title{
                    position: absolute;
                    width:20%;
                    left:20%;
                    color:#444546;
                    font-size: 30px;
                    top:10%;
                    font-weight: bold;
                    border-bottom: 1px solid rgba(130, 130, 130, .3);
                    padding-bottom: 20px;
                }
                .title::before{
                    position: absolute;
                    left:0;
                    bottom:0;
                    content:'';
                    display: inline-block;
                    width:30%;
                    height:1px;
                    background-color: #0068B7;
           }
                .content{
                    position: absolute;
                    width:50%;
                    left:25%;
                    text-align: center;
                    top:40%;
                    line-height:50px;
                    p:nth-child(1){
                        font-size: 25px;
                        color:#0068B7;
                        font-weight: bold;
                    }
                    p:nth-child(2){
                        font-size: 18px;
                        font-family: 'normal';
                    }
                    p:nth-child(3){
                        color:#444546;
                        margin-top: 40px;
                        font-family: light;
                        font-weight: lighter;
                    }
                }
            }
            .two{
                width:100%;
                position: relative;
                img{
                    width:100%;
                    object-fit: cover;
                    display: block;
                    height:420px;
                }
                .content{
                    position: absolute;
                    width:50%;
                    left:25%;
                    text-align: center;
                    top:10%;
                    line-height:50px;
                    color:white;
                    p:nth-child(1){
                        font-size: 25px;
                        font-weight: bold;
                    }
                    p:nth-child(2){
                        font-size: 18px;
                        font-family: 'normal';
                    }
                    p:nth-child(3){
                        margin-top: 40px;
                        font-family: light;
                        font-weight: lighter;
                    }
                }
            }
            .enTwo{
                img{
                    height:650px;
                }
            }
            .three{
                width:1280px;
                margin: 60px auto;
                margin-bottom: 0;
                padding-bottom: 60px;
                .t1{
                    width:100%;
                    text-align: center;
                    p:nth-child(1){
                        font-size: 25px;
                        font-weight: bold;
                        color:#0068B7;
                    }
                    p:nth-child(2){
                        font-size: 18px;
                        font-family: 'normal';
                        margin-top: 10px;
                    }
                }
                .items{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 60px;
                    .item{
                        width:30%;
                        cursor: pointer;
                        transition: all 2s;
                        img{
                            width:100%;
                            object-fit: cover;
                        }
                        .c{
                            width:100%;
                            background-color: #FAFAFA;
                            font-size: 14px;
                            font-family: 'normal';
                            font-weight: lighter;
                            height:120px;
                          padding: 30px 0;
                            p{
                                width:90%;
                                margin-left: 5%;
                                line-height: 30px;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 4;
                                overflow: hidden;
                                transition: all 2s;
                            }
                        }
                    }
                    .item:hover{
                        box-shadow:0px 3px 2px 3px #e2e2e2;
                        .c{
                            p{
                                color:#3B95FF;
                            }
                        }
                    }
                }
            }
        }
        .sh{
            width:100%;
           padding: 80px 0;
            .title{
                width:20%;
                margin-left:18.6%;
                color:#444546;
                font-size: 30px;
                font-weight: bold;
                border-bottom: 1px solid rgba(130, 130, 130, .3);
                padding-bottom: 20px;
                position: relative;
            }
            .title::before{
                position: absolute;
                left:0;
                bottom:0;
                content:'';
                display: inline-block;
                width:30%;
                height:1px;
                background-color:#0068B7;
            }
            .lm{
                width:1280px;
                margin: 60px auto;
               display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                .item{
                    width:30%;
                    margin-top: 50px;
                    margin-left: 3%;
                    cursor: pointer;
                    overflow: hidden;
                    img{
                        width:100%;
                        object-fit: cover;
                        transition: all 2s;
                    }
                    .f{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        font-size: 14px;
                        color:#444546;
                        padding: 15px 0;
                        border-bottom: 1px solid rgba(0,0,0,.1);
                        position: relative;
                        transition: all 2s;
                    }
                    .f::before{
                       position: absolute;
                        content:'';
                        display: inline-block;
                        left:0;
                        bottom:0;
                        width:0;
                        height:1px;
                        background-color: #0068B7;
                        transition: all 1s;
                    }
                    .on{
                        position: relative;
                        overflow: hidden;
                        span{
                            position: absolute;
                            bottom:0;
                            left:0;
                            display: inline-block;
                            padding: 8px 20px;
                            background-color: white;
                            font-family: 'futu';
                            font-size: 14px;
                            color:black;
                        }
                    }
                    .fa{
                        padding: 20px 20px;
                        font-size: 14px;
                        background-color: white;
                        transition: all 2s;
                        p:nth-child(1){
                            border-bottom: 1px solid rgba(0,0,0,.1);
                            position: relative;
                            padding-bottom: 15px;
                            color:black;
                        }
                        p:nth-child(1)::before{
                            position: absolute;
                            content:'';
                            display: inline-block;
                            left:0;
                            bottom:0;
                            width:0;
                            transition: all 1s;
                            height:1px;
                            background-color: #0068B7;
                        }
                        p:nth-child(2){
                            margin-top: 15px;
                            font-size: 13px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            line-height: 25px;
                            color:rgba(0,0,0,.8);
                            transition: all 2s;
                        }
                    }
                }
                .item:hover{
                    img{
                        transform: scale(1.05);
                    }
                    .f{
                        color:#3B95FF;
                    }
                    .f::before{
                        width:100%;
                    }
                    .fa{
                        color:#3B95FF;
                        p:nth-child(1)::before{
                            width:100%;
                        }
                        p:nth-child(2){
                            color:#3B95FF;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1440px){
        .mainCon{
            .sh{
                .title{
                    margin-left:6%;
                }
            }
            .ln{
                .one{
                    .title{
                        left:6%;
                    }
                }
                .two{
                    img{
                        height:500px;
                    }
                }
            }
        }
    }
    @media screen and (max-width:1279px){
        .main{
            .nav{
                width:100%;
                flex-wrap: wrap;
                span{
                    width:100%;
                    padding: 15px 0;
                    text-align: center;
                }
            }
        }
        .mainCon{
            .ln{
                .one{
                    img{
                        height:550px;
                    }
                    .title{
                        width:60%;
                    }
                    .content{
                        width:90%;
                        left:5%;
                        top:25%;
                        p:nth-child(3){
                            margin-top: 20px;
                        }
                    }
                }
                .two{
                    .content{
                        width:90%;
                        left:5%;
                        top:5%;
                        line-height: 40px;
                        p:nth-child(2){
                            margin-top: 10px;
                        }
                        p:nth-child(3){
                            margin-top: 20px;
                        }
                    }
                }
                .three{
                    width:100%;
                    .items{
                        flex-direction: column;
                        width:95%;
                        margin-left: 2.5%;
                        margin-top: 30px;
                        .item{
                            width:100%;
                            margin-top: 40px;
                        }
                    }
                }
            }
            .enln{
                .one{
                    height:800px;
                }
                .two{
                   img{
                       height:1000px;
                   }
                }
            }
            .sh{
                padding: 40px 0;
                .title{
                    width:80%;
                    font-size: 25px;
                }
                .lm{
                    width:95%;
                    margin: 30px auto;
                    .item{
                        width:100%;
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
</style>